import Vue from 'vue'
import Vuex from 'vuex'
import considerations from './modules/considerations';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        considerations
    },
    strict: debug,
})
